import { Service, ContractConstants, DOFlow, } from './../../constants/actionType'
import { InHomeUtils } from './../../util/inhomeUtils'
import * as buildProductAction from './../../action/change/buildProduct';
import { catchJSException } from './../../service/logService';
import { store } from "../../../src/index" /**importing store for reducer values */

export const prefetch = (action, dispatch, visitId, addlInfo, contract, selectedCoreServices, isContractSwitched, isLocalTVInCart, isDCTinCart, isDoFlow, isChecked = false, serviceInCart,VecContractServices='') => {
    try {
        
        serviceInCart = InHomeUtils.isNull(serviceInCart) ? "" : serviceInCart;
        selectedCoreServices = InHomeUtils.isNull(selectedCoreServices) ? "" : selectedCoreServices;
        let coreServiceCount = InHomeUtils.isNotEmpty(serviceInCart) && InHomeUtils.isNotEmpty(serviceInCart.split(",")[0]) ? serviceInCart.split(",").length : 0;
        let flow = action;
        let qualifiedServices = null;
        let servicesInfo = {
            isData: serviceInCart.indexOf('DATA') > -1,
            isDataAdd: serviceInCart.indexOf('DATA') > -1 && selectedCoreServices.indexOf('DATA') === -1,
            isDataRemove: serviceInCart.indexOf('DATA') === -1 && selectedCoreServices.indexOf('DATA') > -1,
            isDataChange: flow.indexOf(Service.internet) > -1 && serviceInCart.indexOf('DATA') > -1 && selectedCoreServices.indexOf('DATA') > -1,

            isTV: serviceInCart.indexOf('VIDEO') > -1,
            isTVAdd: serviceInCart.indexOf('VIDEO') > -1 && selectedCoreServices.indexOf('VIDEO') === -1,
            isTVRemove: serviceInCart.indexOf('VIDEO') === -1 && selectedCoreServices.indexOf('VIDEO') > -1,
            isTVChange: flow.indexOf(Service.tv) > -1 && serviceInCart.indexOf('VIDEO') > -1 && selectedCoreServices.indexOf('VIDEO') > -1,

            isVoice: serviceInCart.indexOf('FIOS_VOICE') > -1,
            isVoiceAdd: serviceInCart.indexOf('FIOS_VOICE') > -1 && selectedCoreServices.indexOf('FIOS_VOICE') === -1,
            isVoiceRemove: serviceInCart.indexOf('FIOS_VOICE') === -1 && selectedCoreServices.indexOf('FIOS_VOICE') > -1,

            isPerks: serviceInCart.indexOf('PERKS') > -1,
            isPerksAdd: serviceInCart.indexOf('PERKS') > -1 && selectedCoreServices.indexOf('PERKS') === -1,
            isPerksRemove: serviceInCart.indexOf('PERKS') === -1 && selectedCoreServices.indexOf('PERKS') > -1,
            isPerksChange: flow.indexOf(Service.perks) > -1 && serviceInCart.indexOf('PERKS') > -1 && selectedCoreServices.indexOf('PERKS') > -1,

            isLocalTV: isLocalTVInCart,
            is300M: false,
            is1G: false,
            isDCT: isDCTinCart,

            isTVinProfileCart : store.getState().app.flowtype === "SUPP" ? InHomeUtils.isNotEmpty(store.getState().buildProduct.tv.selectedProduct) : InHomeUtils.isNotEmpty(store.getState().ecProfileCart.ProfileTVProduct)
        };

        doprefetch(dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow,VecContractServices);
    }
    catch (ex) {
        catchJSException('prefetch', visitId, 'prefetch', ex);
    }
}

const doprefetch = (dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow,VecContractServices='') => {
    try {
        contract = store.getState().signIn && store.getState().signIn.response && 
        (store.getState().signIn.response.classicToFcp || store.getState().signIn.response.userProfile.isFcpInProfile) ? 'MTM' : contract;
        let mm3Qualified = store.getState().buildProduct.internet.mm3Qualified;
        let vecFlow = InHomeUtils.isNotEmpty(store.getState().signIn) && InHomeUtils.isNotEmpty(store.getState().signIn.response) && InHomeUtils.isNotEmpty(store.getState().signIn.response.hoaServiceType) ? true : false;
        let vecData2YContract = store.getState().signIn?.response?.vecMigration && (store.getState().signIn?.response?.flowRoute == "VECREVIEWPLAN" || store.getState().signIn?.response?.flowRoute == "VECMIGRATION") && store.getState().loopQual?.runtimeKey?.VecMTM == "Y" ? false : true 
        window.localStorage.setItem('isLboTriggered', false);
        if (flow === DOFlow.onDoFlowInit && !isDoFlow.DOStatus) {
            //Here getting tarCode = DOIDVALUE 
            if (isDoFlow.isDoFlow && isDoFlow.DOIDValue !== null) {
                //Open Internet Plans by default for BYOB and DO
                //dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                //buildProductAction.fetchDOBundle(dispatch, visitId, addlInfo.zip, addlInfo.state, addlInfo.tarCode, isDoFlow.DOIDValue, addlInfo.masterpackageview);
                buildProductAction.setDCTEligibility(dispatch, addlInfo.state);
            }
        }
        else {
            switch (coreServiceCount) {
                case 0:
                    if (VecContractServices.toLocaleLowerCase().indexOf('data') <0&&contract === ContractConstants.monthToMonth) {
                        fetchAllMTM(dispatch, visitId, addlInfo);
                    }
                    else if (contract === ContractConstants.twoYear||(VecContractServices.toLocaleLowerCase().indexOf('data') >-1)) {
                        if(VecContractServices.toLocaleLowerCase().indexOf('data') > -1 && vecData2YContract)
                        {
                            fetchFiosData2YR(dispatch, visitId, addlInfo);
                            fetchFiosTVMTM(dispatch, visitId, addlInfo);
                            fetchFiosVoiceMTM(dispatch, visitId);
                            fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                        }
                        else if(VecContractServices)
                        {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo);
                            fetchFiosTVMTM(dispatch, visitId, addlInfo);
                            fetchFiosVoiceMTM(dispatch, visitId);
                            fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                        }
                        else
                            fetchAll2YR(dispatch, visitId, addlInfo);
                    }
                    //if(servicesInfo.isVideoQualified){
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId, addlInfo.state);
                    //}
                    // updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                    fetchBasicSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, addlInfo);
                    //Open Internet Plans by default for BYOB and DO
                    //dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'Init' });
                    break;
                case 1:
                    if (servicesInfo.isData) {
                        fetchFiosDataMTM(dispatch, visitId, addlInfo);
                        fetchFiosPerksMTM(dispatch, visitId, addlInfo)

                        if (addlInfo.isFCPflow || mm3Qualified || vecFlow ) {

                            fetchFiosTVMTM(dispatch, visitId, addlInfo);
                        }
                        else {
                            if (!addlInfo.isAlaCarte) {
                                fetchFiosTV2YR(dispatch, visitId, addlInfo);
                            }
                        }
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState);
                        if (addlInfo.isFCPflow) {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                        }
                        else {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TV2YR, dispatch);
                        }
                    }
                    else if (servicesInfo.isTV) {
                        fetchFiosTVMTM(dispatch, visitId, addlInfo);
                        if (addlInfo.isFCPflow || (VecContractServices !== '' && VecContractServices.toLocaleLowerCase().indexOf('data') === -1)) {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo);
                            fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                        }
                        else if (!vecData2YContract){
                            fetchFiosDataMTM(dispatch, visitId, addlInfo);
                        }
                        else {
                            fetchFiosData2YR(dispatch, visitId);
                        }

                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState);
                        if (addlInfo.isFCPflow || (VecContractServices !== '' && VecContractServices.toLocaleLowerCase().indexOf('data') === -1)) {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                        }
                        else {
                            updateServiceLevelContract(ServiceContract.Data2YR, ServiceContract.TVMTM, dispatch);
                        }
                        if (!addlInfo.isAlaCarte) {
                            fetchFiosVoiceMTM(dispatch, visitId);
                        }
                    }
                    if (!addlInfo.isAlaCarte) {
                        fetchFiosVoiceMTM(dispatch, visitId);
                    }
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId, addlInfo.state);
                    break;
                case 2:
                    if (servicesInfo.isVoice) {
                        if (servicesInfo.isData) {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo);
                            fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                            if (addlInfo.isFCPflow || mm3Qualified || servicesInfo.isTVinProfileCart) {
                                fetchFiosTVMTM(dispatch, visitId, addlInfo);
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                            }
                            else {
                                fetchFiosTV2YR(dispatch, visitId, addlInfo);
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TV2YR, dispatch);
                            }
                        }
                        else if (servicesInfo.isTV) {
                            fetchFiosTVMTM(dispatch, visitId, addlInfo);
                            // fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                            if (addlInfo.isFCPflow) {
                                fetchFiosDataMTM(dispatch, visitId);
                                fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                            }
                            else {
                                fetchFiosData2YR(dispatch, visitId);
                                updateServiceLevelContract(ServiceContract.Data2YR, ServiceContract.TVMTM, dispatch);
                            }
                        }
                        fetchFiosVoiceMTM(dispatch, visitId);
                        if (servicesInfo.isVoiceAdd) {
                            fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, addlInfo)
                            if (servicesInfo.isDataAdd ) {
                                fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState);   
                            }
                        }
                        else {
                            fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState);
                            fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState);
                        }
                    }
                    else if (servicesInfo.isData && servicesInfo.isTV) {
                        if (servicesInfo.isLocalTV || contract === ContractConstants.monthToMonth) {
                        if(VecContractServices.toLocaleLowerCase().indexOf('data') > -1 && vecData2YContract)
                        {
                            fetchFiosData2YR(dispatch, visitId, addlInfo);
                        }
                        else
                            fetchAllMTM(dispatch, visitId, addlInfo);
                        }
                        else {
                            fetchAll2YR(dispatch, visitId, addlInfo);
                        }
                        if (!isContractSwitched) {
                            fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState);
                            fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState);
                        }
                        
                    }
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId, addlInfo.state);
                    break;
                case 3:
                    if (VecContractServices.toLocaleLowerCase().indexOf('data') <0&&((contract === ContractConstants.monthToMonth) || servicesInfo.isLocalTV || addlInfo.couponFlowType === "Employee" || addlInfo.couponFlowType === "Retiree")) {
                        fetchAllMTM(dispatch, visitId, addlInfo);
                    }
                    else if (contract === ContractConstants.twoYear||VecContractServices.toLocaleLowerCase().indexOf('data') > -1) {
                        if(VecContractServices.toLocaleLowerCase().indexOf('data') > -1 && vecData2YContract)
                        {
                            fetchFiosData2YR(dispatch, visitId, addlInfo);
                            fetchFiosTVMTM(dispatch, visitId, addlInfo);
                            fetchFiosVoiceMTM(dispatch, visitId);
                            fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                        }
                        else if(VecContractServices)
                        {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo);
                            fetchFiosTVMTM(dispatch, visitId, addlInfo);
                            fetchFiosVoiceMTM(dispatch, visitId);
                            fetchFiosPerksMTM(dispatch, visitId, addlInfo)
                        }
                        else
                        fetchAll2YR(dispatch, visitId, addlInfo);
                    }
                    if (!isContractSwitched) {
                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState);
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState);
                        fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, addlInfo);
                    }
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId, addlInfo.state);
            }
        }

        // if (flow === "INIT" || flow === "SMART_CART") {
        //     buildProductAction.setDCTEligibility(dispatch, addlInfo.state);
        // }
    }
    catch (ex) {
        catchJSException('prefetch', visitId, 'doprefetch', ex);
    }
}


export const fetchBasicSubProducts = (dispatch, visitId, servicesInfo, EquipmentState, addlInfo) => {
    var isTVQualified = store && store.getState() && store.getState().signIn && store.getState().signIn.isTVQualified == true ? true : false;
    
     let isQAMLQ = (store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey)? true : false;
    // let QAMStreamTV = "";
    // let QAMStreamTVLQ = "";
     buildProductAction.getFiosTvOneQualification(dispatch, visitId,false);
    // let isQAMTV = (store && store.getState && store.getState().buildProduct && store.getState().buildProduct.tv.streamTvEligible)? true : false;

    buildProductAction.fetchRouter(dispatch, visitId);
   
    buildProductAction.fetchTechSure(dispatch, visitId);

    if (isTVQualified) {
        InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Vroom) ? buildProductAction.fetchVRoom(dispatch, visitId, servicesInfo.isLocalTV, servicesInfo.isDCT, addlInfo.profileCeParityDevice) : {};
        InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Recording) ? buildProductAction.fetchRecording(dispatch, visitId, addlInfo.couponFlowType) : {};
    }
    // if(isQAMTV)
    // {
    //     QAMStreamTV = store.getState().buildProduct;
    //     QAMStreamTVLQ = store.getState().loopQual;
    // }
    InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.OTT) ? buildProductAction.fetchStreamingServices(visitId, dispatch) : {};
    InHomeUtils.isNotEmpty(addlInfo.selectedProductId) ? buildProductAction.fetchChannel(dispatch, visitId, addlInfo.selectedProductId) : {};
    InHomeUtils.isNotEmpty(addlInfo.selectedProductId) && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.InternationalChannel)) ? buildProductAction.fetchIntrChannel(dispatch, visitId, addlInfo.selectedProductId) : {};
    InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Fne) ? buildProductAction.fetchFne(dispatch, visitId) : {};

    fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, EquipmentState, addlInfo);
    //buildProductAction.fetchFiosTvOneOptions(dispatch, visitId,QAMStreamTV,QAMStreamTVLQ);
    ((addlInfo.state === "MD" && (servicesInfo.isTVAdd || servicesInfo.isTVinProfileCart)) || (addlInfo.profileDctProduct !== undefined && addlInfo.profileDctProduct !== null)) && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.DCT)) ? buildProductAction.fetchDCT(dispatch, visitId) : {};

    if (isTVQualified) {
        ((addlInfo.enableConnectedTv) && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Ceapps)))?
        buildProductAction.fetchCeapps(dispatch, visitId, addlInfo.couponFlowType, addlInfo.profileVRoomProduct) : {};
    }
}


export const fetchDataSubProducts = (dispatch, visitId, servicesInfo, EquipmentState) => {
    servicesInfo.isDataAdd || servicesInfo.isDataChange ? buildProductAction.fetchRouter(dispatch, visitId) : {};
    InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.OTT) ? buildProductAction.fetchStreamingServices(visitId, dispatch) : {};
    servicesInfo.isDataAdd || servicesInfo.isDataChange || servicesInfo.isVoiceAdd || servicesInfo.isVoiceRemove ? buildProductAction.fetchTechSure(dispatch, visitId) : {};
    servicesInfo.isDataAdd || servicesInfo.isDataChange ? buildProductAction.fetchFne(dispatch, visitId): {};
}
export const fetchDataSubProductsOnClearCart = (dispatch, visitId)=>{
    buildProductAction.fetchRouter(dispatch, visitId)
    buildProductAction.fetchFne(dispatch, visitId)
    buildProductAction.fetchTechSure(dispatch, visitId)
}

export const fetchVideoSubProducts = (dispatch, visitId, addlInfo, servicesInfo, EquipmentState) => {
    !servicesInfo.isData && !servicesInfo.isTVChange ? buildProductAction.fetchRouter(dispatch, visitId) : {};
    if (servicesInfo.isTVAdd || servicesInfo.isTVChange) {
        if (addlInfo.isFCPflow) {
            buildProductAction.fetchVRoom(dispatch, visitId, servicesInfo.isLocalTV, servicesInfo.isDCT);
            buildProductAction.fetchRecording(dispatch, visitId, addlInfo.couponFlowType);
        }
        else {
            InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Vroom) ? buildProductAction.fetchVRoom(dispatch, visitId, servicesInfo.isLocalTV, servicesInfo.isDCT) : {};
            InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Recording) ? buildProductAction.fetchRecording(dispatch, visitId, addlInfo.couponFlowType) : {};
        }
        servicesInfo.isData ? buildProductAction.fetchStreamingServices(visitId, dispatch) : {};
        buildProductAction.fetchChannel(dispatch, visitId, addlInfo.selectedProductId);
        ((addlInfo.state === "MD" && (servicesInfo.isTVAdd || servicesInfo.isTVinProfileCart)) || ((addlInfo.profileDctProduct !== undefined && addlInfo.profileDctProduct !== null))) && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.DCT)) ? buildProductAction.fetchDCT(dispatch, visitId) : {};
        InHomeUtils.isNotEmpty(addlInfo.selectedProductId) && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.InternationalChannel)) ? buildProductAction.fetchIntrChannel(dispatch, visitId, addlInfo.selectedProductId) : {};
        (addlInfo.enableConnectedTv) ? buildProductAction.fetchCeapps(dispatch, visitId, addlInfo.couponFlowType) : {};
    }
}

export const fetchFiosVoiceSubProducts = (dispatch, visitId, servicesInfo, EquipmentState, addlInfo) => {
    let vecFlow = InHomeUtils.isNotEmpty(store.getState().signIn) && InHomeUtils.isNotEmpty(store.getState().signIn.response) && InHomeUtils.isNotEmpty(store.getState().signIn.response.hoaServiceType) ? true : false;
    if (InHomeUtils.isNull(EquipmentState)) {
        buildProductAction.fetchListing(dispatch, visitId);
        buildProductAction.fetchBackup(dispatch, visitId);
        if(addlInfo.enableMixmatch2 || vecFlow) {
            buildProductAction.fetchIntlPlans(dispatch, visitId);
        }
    }
    else {
        !EquipmentState.Listing ? buildProductAction.fetchListing(dispatch, visitId) : {};
        !EquipmentState.Backup ? buildProductAction.fetchBackup(dispatch, visitId) : {};
        if(addlInfo.enableMixmatch2 || vecFlow) {
            buildProductAction.fetchIntlPlans(dispatch, visitId);
        }
    }
}

export const fetchFiosData2YR = (dispatch, visitId) => {
    buildProductAction.fetchData2Y(dispatch, visitId);
}

export const fetchFiosDataMTM = (dispatch, visitId, addlInfo, value) => {
    console.log("fetch data for change")
    if (InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotNull(addlInfo.couponFlowType)) {
        buildProductAction.fetchDataMTM(dispatch, visitId, addlInfo.couponFlowType, 0, value);
    }
    else {
        buildProductAction.fetchDataMTM(dispatch, visitId, addlInfo.couponFlowType, 0, value);
    }

}
export const fetchFiosPerksMTM = (dispatch, visitId, addlInfo, value) => {
    console.log("fetch perk for change");
    if (InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotNull(addlInfo.couponFlowType)) {
        buildProductAction.fetchPerksMTM(dispatch, visitId, addlInfo.couponFlowType, 0, value);
    }
    else {
        buildProductAction.fetchPerksMTM(dispatch, visitId, addlInfo.couponFlowType, 0, value);
    }

}
export const fetchFiosPerks2YR = (dispatch, visitId, addlInfo, value) => {
    if (InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotNull(addlInfo.couponFlowType)) {
        buildProductAction.fetchPerks2Y(dispatch, visitId, addlInfo.couponFlowType, 0, value);
    }
    else {
        buildProductAction.fetchPerks2Y(dispatch, visitId, addlInfo.couponFlowType, 0, value);
    }

}

export const fetchFiosTV2YR = (dispatch, visitId, addlInfo) => {
    if (store && store.getState() && store.getState().signIn && store.getState().signIn.isTVQualified == true) {
        buildProductAction.fetchTV2Y(dispatch, visitId, addlInfo.zip, addlInfo.tarCode, addlInfo.masterpackageview);
    }
}

export const fetchFiosTVMTM = (dispatch, visitId, addlInfo) => {
    if (store && store.getState() && store.getState().signIn && store.getState().signIn.isTVQualified == true) {
        if (InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotNull(addlInfo.couponFlowType)) {
            buildProductAction.fetchTVMTM(dispatch, visitId, addlInfo.zip, addlInfo.tarCode, addlInfo.masterpackageview, false, addlInfo.couponFlowType);
        }
        else {
            buildProductAction.fetchTVMTM(dispatch, visitId, addlInfo.zip, addlInfo.tarCode, addlInfo.masterpackageview);
        }
    }
}

export const prefetchFiosFiveBasicChannels = (dispatch, zipCode, regionId, state) => {
    buildProductAction.fetchRegionId(dispatch, zipCode, '', store.getState().app.visitId, store.getState().app.visitorId, state);
}

export const fetchFiosVoice2YR = (dispatch, visitId) => {
    if(servicesQualified("voice")){
    buildProductAction.fetchVoice2Y(dispatch, visitId);
    }
}

export const fetchFiosVoiceMTM = (dispatch, visitId) => {
    if(servicesQualified("voice")){
    buildProductAction.fetchVoiceMTM(dispatch, visitId);
    }
}

export const servicesQualified = (type) => {
     try{
    const signIn  =  store.getState().signIn
            let serviceQualified = signIn.response && signIn.response.services && signIn.response.services.filter(each=>each.servicename.toLowerCase()==type)
            serviceQualified = serviceQualified.length > 0 && serviceQualified[0].qualified =="Y"
            return serviceQualified
     }catch(error){
         console.log("error")
     }
}

export const fetchAll2YR = (dispatch, visitId, addlInfo) => {
    fetchFiosData2YR(dispatch, visitId);
    fetchFiosTV2YR(dispatch, visitId, addlInfo);
    fetchFiosVoice2YR(dispatch, visitId);
    fetchFiosPerks2YR(dispatch, visitId, addlInfo)
    updateServiceLevelContract(ServiceContract.Data2YR, ServiceContract.TV2YR, dispatch);
}

export const fetchAllMTM = (dispatch, visitId, addlInfo) => {
    fetchFiosDataMTM(dispatch, visitId, addlInfo);
    fetchFiosTVMTM(dispatch, visitId, addlInfo);
    fetchFiosVoiceMTM(dispatch, visitId);
    fetchFiosPerksMTM(dispatch, visitId, addlInfo)
    updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
}

export const updateServiceLevelContract = (DataContract, TVContract, dispatch) => {
    if (InHomeUtils.isNotNull(DataContract)) {
        dispatch({ type: 'UPDATE_DATA_CONTRACT', value: DataContract });
    }
    if (InHomeUtils.isNotNull(TVContract)) {
        dispatch({ type: 'UPDATE_VIDEO_CONTRACT', value: TVContract });
    }
}

export const ServiceContract = {
    DataMTM: "MTM",
    Data2YR: "2YR",
    TVMTM: "MTM",
    TV2YR: "2YR"
}
